import React, { useEffect, useState } from "react";
import { makeStyles, Grid } from "@material-ui/core";

import { header } from "../../sample";
import { ShaDowBox } from "../../../../../components/boxes";
import SettingHeader from "../../../../../components/SettingHeader";
import CompanyDetails from "./CompanyDetails";
// import AttachmentCard from "./AttachmentCard";
import { SettingActions } from "../../../../../components/SettingHeader/settingActions";
import endPoints from "../../../../../services/apiEndPoints";
import { api, getData } from "../../../../../services";
import { useDispatch } from "react-redux";
import { setCSC } from "../../../../../redux/auth/actions";
import { selectCluster } from "../../../../../redux/selectCSC/actions";

export const useStyles = makeStyles(() => ({
  main: {
    marginLeft: 50,
    paddingTop: 40,
    paddingBottom: 80,
  },
  inputContainer: {
    marginTop: 30,
    display: "flex",
    justifyContent: "space-between",
  },
  attechmentText: {
    fontSize: 14,
    fontWeight: 700,
  },
}));

export const CompanySettings = () => {
  const classes = useStyles();
  const [companyData, setCompanyData] = useState();
  const [uploading, setUploading] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState("");
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();

  useEffect(() => {
    getInitialData();
  }, []);

  const getInitialData = async () => {
    getData(endPoints.COMPANY_SETTINGS, (data) => {
      setCompanyData(data);
    });
    getData("/auth/csc/", (data) => {
      dispatch(setCSC(data));
      dispatch(selectCluster(data.clusters[0]));
    });
  };
  const uploadImage = (e) => {
    updateCompanyDetails("logo", e.target.files[0]);
    setUploading(false);
  };

  const handleInputsChange = (key, value) => {
    setCompanyData({ ...companyData, [key]: value });
  };

  useEffect(() => {
    if (selectedAddress) {
      setCompanyData({ ...companyData, company_address: selectedAddress });
      updateCompanyDetails("company_address", selectedAddress);
    }
  }, [selectedAddress]);

  const updateCompanyDetails = async (key, updateDetail) => {
    try {
      let data = new FormData();
      data.append(key, updateDetail);
      const response = await api.patch(endPoints.COMPANY_SETTINGS, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (response) {
        getInitialData();
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <SettingActions />
      <ShaDowBox>
        <Grid className={classes.main}>
          <SettingHeader
            title={header.Companysettings.title}
            subtitle={header.Companysettings.subtitle}
            img={header.Companysettings.img}
          />
          <Grid className={classes.inputContainer}>
            <CompanyDetails
              uploadImage={uploadImage}
              uploading={uploading}
              companyData={companyData}
              handleInputsChange={handleInputsChange}
              setSelectedAddress={setSelectedAddress}
              updateCompanyDetails={updateCompanyDetails}
              setErrors={setErrors}
              errors={errors}
            />

            {/* <Grid item xs={6} style={{ marginTop: "20px" }}>
              <Grid>`
                <Typography variant="h6" className={classes.attechmentText}>
                  ATTACHMENTS
                </Typography>
                {companyData?.attachments?.map((item, i) => {
                  return (
                    <Grid style={{ marginTop: "20px" }} key={i}>
                      <AttachmentCard
                        docName={item.docName}
                        docDate={item.docDate}
                        docSize={item.docSize}
                        docIcon={item.docIcon}
                        xs={10}
                      />
                    </Grid>
                  );
                })}
              </Grid>
            </Grid> */}
          </Grid>
        </Grid>
      </ShaDowBox>
    </>
  );
};
